import { render, staticRenderFns } from "./dropzone-wrapper.vue?vue&type=template&id=09d18456"
import script from "./dropzone-wrapper.vue?vue&type=script&lang=js"
export * from "./dropzone-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports